import React from 'react';

export const InfoCircleOutline = ({width, height, fill}) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height}>
      <path
        d='M9.2 7.6h1.6V6H9.2zm0 6.4h1.6V9.2H9.2zm.792 4A8 8 0 1 1 18 10a8 8 0 0 1-8.008 8zM10 3.6a6.4 6.4 0 1 0 6.4 6.4A6.4 6.4 0 0 0 10 3.6z'
        fill={fill}
        transform='translate(-2 -2)'
      />
    </svg>
  );
};

InfoCircleOutline.defaultProps = {
  width: 16,
  height: 16,
  fill: 'var(--white)',
};
